import React from 'react';
import * as Styled from './AskProductOrderDetailsItem.styles';
import { IProduct } from '../../types';

interface AskProductOrderDetailsItemProps {
  product: IProduct;
  compact?: boolean;
}

const MAX_TITLE_LENGTH = 14;

export const AskProductOrderDetailsItem: React.FC<
  AskProductOrderDetailsItemProps
> = ({ product, compact }) => {
  return (
    <>
      <Styled.Item compact={compact}>
        <Styled.ItemCover bg={product.photo} />
        {product.product_name.length > MAX_TITLE_LENGTH && !compact && (
          <Styled.Tooltip>{product.product_name}</Styled.Tooltip>
        )}
        <Styled.ItemInfo>
          <Styled.ItemCategory fontWeight={600}>
            {product.attribute_set_name}
          </Styled.ItemCategory>
          <Styled.ItemName variant="tiny" fontWeight={400}>
            {product.product_name}
          </Styled.ItemName>
        </Styled.ItemInfo>
      </Styled.Item>
    </>
  );
};
